import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'Rizzahra | Premium Abayas & Modern Islamic Fashion',
  description = 'Shop elegant modern abayas at Rizzahra. Premium quality Islamic clothing with contemporary designs. Modest fashion for the modern woman since 2025.',
  keywords = 'abayas, islamic clothing, modest fashion, hijab, modern abayas, premium abayas, muslim clothing, abaya store, islamic fashion',
  image = '/default-og-image.jpg',
  url = '',
  type = 'website',
}) => {
  const siteUrl = 'https://rizzahra.store'; // Update with your actual domain
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const fullImage = image.startsWith('http') ? image : `${siteUrl}${image}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content="Rizzahra" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content="Rizzahra" />
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  );
};

export default SEO;
